import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { CustomAttributeFieldType } from "src/app/inventory/sales-order/constants/constants";


@Component({
    selector: "app-custom-attribute-overview",
    templateUrl: "./custom-attribute-overview.component.html",
    styleUrls: ["./custom-attribute-overview.component.scss"],
})
export class CustomAttributeOverviewComponent implements OnChanges {
    @Input() fieldType;
    @Input() customFieldData;

    fieldTypes = CustomAttributeFieldType;

    constructor(public app: AppMainComponent) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.customFieldData && changes.customFieldData.currentValue) {
            this.customFieldData = changes.customFieldData.currentValue;
        }
    }

    getFormattedData(field) {
        if (field && field?.value && field?.value.length > 0) {
            let d = "";
            field.value.forEach((f) => {
                d += f.name + ",";
            });
            return d.substring(0, d.length - 1);
        } else {
            return "";
        }
    }
}
